// ACESSO-01 (L8b): os escopos das rotas das quatro seções (`powerflow.routes.js`): Flows e Execuções, o Cofre e as
// Ferramentas.
const ESCOPOS_DA_ABA = ['powerflow:read', 'vault:use', 'poweragents:write'];

/**
 * O item "PowerFlow" da barra lateral, com as quatro seções da aba, ou nada.
 *
 * FLOW-06 (SPEC S5, R10; Gate 1, Q4; PLAN G18): a aba PowerFlow no primeiro nível do menu, logo depois
 * do PowerAgents, com Flows, Execuções, Cofre e Ferramentas. A régua é a do item PowerAgents e a do
 * gestor do cofre (`useGestorDoCofre`): o super-admin sempre, por ser papel da plataforma; na conta com
 * a flag PowerAgents, o administrador e quem recebeu `poweragents_manage` num papel personalizado. O
 * atendente fica de fora. É a régua do servidor (`ReguaDaAbaPowerflow`) e a das rotas
 * (`powerflow.routes.js`). Com ela, o item PowerTools de Configurações saiu, para todos (Gate 1, Q4).
 *
 * Mora aqui, e não solto no `computed` de `Sidebar.vue`, para o spec alcançar a regra — a lição do
 * `powerAppMenu` e do `powerDataMenu`. O item não tem `to`: o cabeçalho de um grupo com filhos abre o
 * primeiro filho (`SidebarGroup`), e o detalhe de uma execução acende "Execuções".
 *
 * @param {Object} options
 * @param {Function} options.t - o `t` do vue-i18n
 * @param {Function} options.accountScopedRoute - de `useAccount`
 * @param {boolean} options.isSuperAdmin - de `useAdmin`
 * @param {boolean} options.contaComFlag - a flag `power_agents` na conta atual
 * @param {boolean} options.isAdmin - de `useAdmin`: administrador na conta atual
 * @param {boolean} [options.concedidoPorPapel] - `poweragents_manage` recebida num papel personalizado
 * @param {Function} [options.decide] - o `decide` do `useAcesso` (ACESSO-01, L8b): com a chave
 *   ACESSO_GRANULAR ligada, basta um dos escopos das quatro seções (`ESCOPOS_DA_ABA`), e cada seção
 *   aparece pelo da rota dela (`provider.js`, `isAllowed`); desligada, o gestor, como acima. A flag
 *   continua por cima, como no servidor. Sem ele, o gestor.
 * @returns {Array<Object>} o item, ou vazio
 */
export function buildPowerFlowItems({
  t,
  accountScopedRoute,
  isSuperAdmin,
  contaComFlag,
  isAdmin,
  concedidoPorPapel = false,
  decide = (_escopo, hoje) => hoje(),
}) {
  const entra =
    isSuperAdmin ||
    (contaComFlag &&
      decide(ESCOPOS_DA_ABA, () => isAdmin || concedidoPorPapel));
  if (!entra) return [];

  return [
    {
      name: 'PowerFlow',
      icon: 'i-lucide-workflow',
      label: t('SIDEBAR.POWERFLOW.TITLE'),
      children: [
        {
          name: 'PowerFlow Flows',
          label: t('SIDEBAR.POWERFLOW.FLOWS'),
          icon: 'i-lucide-workflow',
          to: accountScopedRoute('powerflow_flows'),
          activeOn: ['powerflow_flows', 'powerflow_gatilho'],
        },
        {
          name: 'PowerFlow Execucoes',
          label: t('SIDEBAR.POWERFLOW.EXECUTIONS'),
          icon: 'i-lucide-history',
          to: accountScopedRoute('powerflow_execucoes'),
          activeOn: ['powerflow_execucoes', 'powerflow_execucao'],
        },
        {
          name: 'PowerFlow Cofre',
          label: t('SIDEBAR.POWERFLOW.VAULT'),
          icon: 'i-lucide-key-round',
          to: accountScopedRoute('powerflow_cofre'),
          activeOn: ['powerflow_cofre'],
        },
        {
          name: 'PowerFlow Ferramentas',
          label: t('SIDEBAR.POWERFLOW.TOOLS'),
          icon: 'i-lucide-wrench',
          to: accountScopedRoute('powerflow_ferramentas'),
          activeOn: ['powerflow_ferramentas'],
        },
      ],
    },
  ];
}
